import { useQuery } from '@tanstack/react-query';
import { getPortfolioHistory } from 'services/portfolios/portfolioService';

const useGetPortfolioHistory = (portfolioUid: string) => {
  return useQuery({
    queryKey: ['useGetPortfolioHistory', portfolioUid],
    queryFn: () => getPortfolioHistory(portfolioUid),
  });
};

export default useGetPortfolioHistory;
